import { useTranslation } from "react-i18next";
import TableCell from "../../common/table/tableCell";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AlertMessageModal from "../../alertMessageModal";
import { useState } from "react";
import TextTooltip from "../../common/TextTooltip";
import { getUIFormattedDate } from "../../../utils/helpers";

const Row = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  /**
   * Get state variables from redux store
   */
  const { citizens } = useSelector((state: any) => state);
  const { editCitizen } = citizens;

  /**
   * redirect to survey detail with params: urlHistory
   */
  const handleRedirect = () => {
    navigate(`/enrollment/survey-detail/${props.surveyDataRow._id}`, {
      state: {
        urlHistory: `/enrollment/citizen-detail/${editCitizen._id}`,
        citizenId: editCitizen._id,
        surveyFieldId: props.surveyDataRow.survey,
      },
    });
  };

  /**
   * handle popup modal
   */
  const hadleModal = () => {
    setShowModal(!showModal);
    props.handleDelete(props.surveyDataRow._id);
  };

  const surveyCreatedMonth = Number(
    moment(props.surveyDataRow.createdOn).format("M")
  );
  const currentMonth = Number(moment().month() + 1);

  /**
   * Don't allow to delete survey for past months. allow only for current month.
   */
  const isAllowSurveyDelete = surveyCreatedMonth === currentMonth;

  return (
    <>
      <tr className="tablePharmacies">
        <TableCell label={props.surveyDataRow.campaign} class="column-width" />
        <TableCell label={props.surveyDataRow.name} />
        <TableCell label={getUIFormattedDate(props.surveyDataRow.createdOn)} />
        <TableCell
          label={getUIFormattedDate(props.surveyDataRow.data_somministrazione)}
        />
        <td className="text-end disabled">
          <span
            className="material-icons info-fill-icon"
            onClick={() => handleRedirect()}
          >
            info
          </span>

          {isAllowSurveyDelete ? (
            <span
              className="ms-2 material-icons info-fill-icon"
              onClick={() => setShowModal(true)}
            >
              delete_outline
            </span>
          ) : (
            <TextTooltip
              position="left"
              tooltipText={t("tooltip.survey-answer-delete")}
            >
              <span
                className="ms-2 material-icons info-fill-icon tooltip-disabled"
                onClick={() => {}}
              >
                delete_outline
              </span>
            </TextTooltip>
          )}
        </td>
      </tr>
      <AlertMessageModal
        title={t("delete-survey")}
        description={
          <div className="showCharacters">
            <span>{t("popup-delete.message-layout.delete-title")}:</span>
            <br />
            <span>
              {t("popup-delete.message-layout.name")}{" "}
              <b>{props.surveyDataRow.name}</b>
            </span>
            <br />
            <span>
              {t("popup-delete.message-layout.created-on")}
              <b> {getUIFormattedDate(props.surveyDataRow.createdOn)}</b>
            </span>
            <br />
            <span>
              {t("popup-delete.message-layout.code")}{" "}
              <b>{editCitizen?.crm?.extraFields?.fiscalcode?.value}</b>
            </span>

            <div className="mt-2">
              {t("popup-delete.message-layout.description")}
            </div>
          </div>
        }
        closeModal={() => setShowModal(false)}
        titleButtonPrimary={t("popup-delete.yes")}
        handleClosePrimary={hadleModal}
        titleButtonSecondary={t("popup-delete.no")}
        handleCloseSecondary={() => setShowModal(false)}
        classNameButtons="w-25"
        show={showModal}
      />
    </>
  );
};

export default Row;
